
import { Component, Mixins } from "vue-property-decorator";
import AuthenticateMixin from "../../../common/mixins/auth.mixin";
import routes from "@/views/base/routes";

import { RouteConfig } from "vue-router";

@Component
export default class Navigation extends Mixins(AuthenticateMixin) {
  routes: (RouteConfig | undefined)[] = routes.flatMap((route: RouteConfig) => route.children);

  isRouteVisible(route: RouteConfig): boolean {
    return route.meta?.roles?.some((role: string) => role === this.userInfo()?.role);
  }

  getSelectedStyle(name: string): string {
    return this.$route.name == name ? 'color: #315564' : 'color: white';
  }

  get notificationRoute(): RouteConfig | undefined {
    return this.routes.find(route => route?.name === "Notifications");
  }
}
